import { Action } from '../actions';
import {
    FETCH_PREDICTOR_EDITOR,
    FetchPredictorEditorAction,
    INITIAL_PREDICTOR_EDITOR,
    InitialPredictorEditorAction,
    SHOW_PREDICTOR_EDITOR_ERROR,
    ShowPredictorEditorErrorAction,
    UPDATE_PREDICTOR_EDITOR,
    UpdatePredictorEditorAction
} from '../actions/predictorEditor';
import { PredictorData } from '../typings/predictor';

const updatePredictorEditorData = (state: PredictorData, action: UpdatePredictorEditorAction): PredictorData => {
    return {
        ...state,
        isLoading: false,
        detailed: action.data.detailed,
        basic: action.data.basic,
        otsBasic: action.data.otsBasic,
        otsDetailed: action.data.otsDetailed,
        id: action.data.reqId,
        error: ''
    };
};

const fetchPredictorEditorData = (state: PredictorData, action: FetchPredictorEditorAction): PredictorData => {
    return {
        ...state,
        isLoading: true,
        error: '',
        isExpanderOpened: false
    };
};

const showPredictorEditorError = (state: PredictorData, action: ShowPredictorEditorErrorAction): PredictorData => {
    return {
        ...state,
        isLoading: false,
        error: action.errorMassage
    };
};

const initialPredictorReachEditorData = (state: PredictorData, action: InitialPredictorEditorAction): PredictorData => {
    return action.data;
};

export const initialPredictorEditorState: PredictorData = {
    isLoading: false,
    isLoadingRecommendation: false,
    isExpanderOpened: false
};

export function predictorEditor(state: PredictorData = initialPredictorEditorState, action: Action): PredictorData {
    switch (action.type) {
        case FETCH_PREDICTOR_EDITOR:
            return fetchPredictorEditorData(state, action);
        case UPDATE_PREDICTOR_EDITOR:
            return updatePredictorEditorData(state, action);
        case SHOW_PREDICTOR_EDITOR_ERROR:
            return showPredictorEditorError(state, action);
        case INITIAL_PREDICTOR_EDITOR:
            return initialPredictorReachEditorData(state, action);
        default:
            return state;
    }
}
